import { CompanyScopedRoutePathEnum, type CompanyScopedRoutePathType } from "@finway-group/shared/lib/consts/route.constants"

export enum RoutePathEnum {
    // auth
    LOGIN = "/login",
    RESET_TOKEN = "/reset/:token",
    FORGOT_PASSWORD = "/forgot-password",
    NEW_PASSWORD = "/new-password",
    RESET_PASSWORD = "/reset/:token", // TODO this is WRONG(!)
    CONFIRM_EMAIL = "/email/verify/:token",
    // auth0 routes
    AUTH_ERROR = "/auth-error",
    NO_ACCESS = "/no-access",
    LOGGED_IN = "/loggedin",
    DEFORCE_SSO = "/deforce-sso/:code",

    // others
    ERROR = "/error",
    ROOT = "/",
    GLOBAL = "/*",
}

// Re-export company-scoped routes from shared package
export { CompanyScopedRoutePathEnum, CompanyScopedRoutePathType }

export interface SettingsTabRouteMatchInterface<T = string> {
    settingsTab: T
}

export type PaymentSettingsTabRoutes =
    | typeof CompanyScopedRoutePathEnum.SETTINGS_BILLING_TAB_PLAN
    | typeof CompanyScopedRoutePathEnum.SETTINGS_BILLING_TAB_PAYMENT_METHOD
    | typeof CompanyScopedRoutePathEnum.SETTINGS_BILLING_TAB_INVOICES
